import { render, staticRenderFns } from "./SearchName.vue?vue&type=template&id=2d111a90&scoped=true&"
import script from "./SearchName.vue?vue&type=script&lang=js&"
export * from "./SearchName.vue?vue&type=script&lang=js&"
import style0 from "./SearchName.vue?vue&type=style&index=0&id=2d111a90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d111a90",
  null
  
)

export default component.exports